import { apiRequest } from '@/api/request.js'
export const listAreaOptions = (params = {}) => {
  return apiRequest({
    ...params,
    url: '/mall4cloud_order/area/list',
    method: 'GET'
  })
}
export const listAreaByParentId = (params = {}) => {
  return apiRequest({
    ...params,
    url: '/mall4cloud_order/area/list_by_pid',
    method: 'GET'
  })
}
export const getCurrentCity = (params = {}) => {
  return apiRequest({
    ...params,
    url: '/mall4cloud_order/area/ua/get_current_city',
    method: 'GET'
  })
}
export const getDeliveryCompanyList = (params = {}) => {
  return apiRequest({
    ...params,
    url: '/mall4cloud_order/delivery_company/list',
    method: 'GET'
  })
}
export const getDeliveryOrder = (params = {}) => {
  const { deliveryOrderId, ...requestParams } = params
  return apiRequest({
    ...requestParams,
    url: `/mall4cloud_order/my_delivery/delivery_order/${deliveryOrderId}`,
    method: 'GET'
  })
}
export const getDeliveryOrderInfo = (params = {}) => {
  const { orderId, ...requestParams } = params
  return apiRequest({
    ...requestParams,
    url: `/mall4cloud_order/my_delivery/order_info/${orderId}`,
    method: 'GET'
  })
}
export const getOrderTrack = (params = {}) => {
  return apiRequest({
    ...params,
    url: '/mall4cloud_order/my_order/order_track',
    method: 'GET'
  })
}
export const getFlashOrderTrack = (params = {}) => {
  return apiRequest({
    ...params,
    url: '/mall4cloud_order/flash_order_track/list_by_order_id',
    method: 'GET'
  })
}
export const deleteMyOrder = (params = {}) => {
  const { orderId, ...requestParams } = params
  return apiRequest({
    ...requestParams,
    url: `/mall4cloud_order/my_order/${orderId}`,
    method: 'DELETE'
  })
}
export const cancelMyOrder = (params = {}) => {
  const { orderId, ...requestParams } = params
  return apiRequest({
    ...requestParams,
    url: `/mall4cloud_order/my_order/cancel/${orderId}`,
    method: 'PUT'
  })
}
export const receiptMyOrder = (params = {}) => {
  const { orderId, ...requestParams } = params
  return apiRequest({
    ...requestParams,
    url: `/mall4cloud_order/my_order/receipt/${orderId}`,
    method: 'PUT'
  })
}
export const deleteMyFlashOrder = (params = {}) => {
  const { orderId, ...requestParams } = params
  return apiRequest({
    ...requestParams,
    url: `/mall4cloud_order/my_flash_order/${orderId}`,
    method: 'DELETE'
  })
}
export const cancelMyFlashOrder = (params = {}) => {
  const { orderId, ...requestParams } = params
  return apiRequest({
    ...requestParams,
    url: `/mall4cloud_order/my_flash_order/cancel/${orderId}`,
    method: 'PUT'
  })
}
export const receiptMyFlashOrder = (params = {}) => {
  const { orderId, ...requestParams } = params
  return apiRequest({
    ...requestParams,
    url: `/mall4cloud_order/my_flash_order/receipt/${orderId}`,
    method: 'PUT'
  })
}
export const getOrderById = (params = {}) => {
  return apiRequest({
    ...params,
    url: '/mall4cloud_order/my_order/get_by_order_id',
    method: 'GET'
  })
}
export const getFlashOrderById = (params = {}) => {
  return apiRequest({
    ...params,
    url: '/mall4cloud_order/my_flash_order/get_by_order_id',
    method: 'GET'
  })
}
export const getOrderByWriteOffCode = (params = {}) => {
  return apiRequest({
    ...params,
    url: '/mall4cloud_order/my_order/get_by_write_off_code',
    method: 'GET'
  })
}
export const getFlashOrderByWriteOffCode = (params = {}) => {
  return apiRequest({
    ...params,
    url: '/mall4cloud_order/my_flash_order/get_by_write_off_code',
    method: 'GET'
  })
}
export const getOrderStatusOptions = (params = {}) => {
  return apiRequest({
    ...params,
    url: '/mall4cloud_order/my_order/get_order_status',
    method: 'GET'
  })
}
export const queryMyOrderCount = (params = {}) => {
  return apiRequest({
    ...params,
    url: '/mall4cloud_order/my_order/order_count',
    method: 'GET'
  })
}
export const queryMyFlashOrderCount = (params = {}) => {
  return apiRequest({
    ...params,
    url: '/mall4cloud_order/my_flash_order/order_count',
    method: 'GET'
  })
}
// 校验用户扫码识别出的订单，并返回脱敏后的订单详情。
export const scanMyOrder = (params = {}) => {
  return apiRequest({
    ...params,
    url: '/mall4cloud_order/my_order/scan',
    method: 'GET'
  })
}
// 查询闪购待付款订单。
export const listFlashWaitPayOrders = (params = {}) => {
  return apiRequest({
    ...params,
    url: '/mall4cloud_order/my_flash_order/wait_pay_orders',
    method: 'GET'
  })
}
// 查询闪购订单的最新再购商品明细。
export const getFlashRepurchaseList = (params = {}) => {
  return apiRequest({
    ...params,
    url: '/mall4cloud_order/my_flash_order/repurchase_list',
    method: 'POST'
  })
}
export const getMyOrderDetail = (params = {}) => {
  return apiRequest({
    ...params,
    url: '/mall4cloud_order/my_order/order_detail',
    method: 'GET'
  })
}
export const getMyFlashOrderDetail = (params = {}) => {
  return apiRequest({
    ...params,
    url: '/mall4cloud_order/my_flash_order/order_detail',
    method: 'GET'
  })
}
export const getFlashOrderRiderLocation = (params = {}) => {
  return apiRequest({
    ...params,
    url: '/mall4cloud_order/my_flash_order/rider_location',
    method: 'GET'
  })
}
export const searchMyOrders = (params = {}) => {
  return apiRequest({
    ...params,
    url: '/mall4cloud_order/my_order/search_order',
    method: 'GET'
  })
}
export const searchMyFlashOrders = (params = {}) => {
  return apiRequest({
    ...params,
    url: '/mall4cloud_order/my_flash_order/search_order',
    method: 'GET'
  })
}
export const getStationOrderDetail = (params = {}) => {
  return apiRequest({
    ...params,
    url: '/mall4cloud_order/my_station_order/station_detail',
    method: 'GET'
  })
}
export const getFlashStationOrderDetail = (params = {}) => {
  return apiRequest({
    ...params,
    url: '/mall4cloud_order/my_station_flash_order/station_detail',
    method: 'GET'
  })
}
export const listStationOrdersByStationId = (params = {}) => {
  return apiRequest({
    ...params,
    url: '/mall4cloud_order/my_station_order/get_order_by_station_id',
    method: 'GET'
  })
}
export const listStationOrdersByShopId = (params = {}) => {
  return apiRequest({
    ...params,
    url: '/p/my_station_order/get_order_by_shopId',
    method: 'GET'
  })
}
export const getOrderInvoiceInfo = (params = {}) => {
  return apiRequest({
    ...params,
    url: '/mall4cloud_order/order_invoice',
    method: 'GET'
  })
}
export const getOrderPayInfo = (params = {}) => {
  return apiRequest({
    ...params,
    url: '/mall4cloud_order/order/order_pay_info',
    method: 'GET'
  })
}
export const getFlashOrderPayInfo = (params = {}) => {
  return apiRequest({
    ...params,
    url: '/mall4cloud_order/flash_order/order_pay_info',
    method: 'GET'
  })
}
export const getOrderRefundInfo = (params = {}) => {
  return apiRequest({
    ...params,
    url: '/mall4cloud_order/order_refund/info',
    method: 'GET'
  })
}
export const getFlashRefundInfo = (params = {}) => {
  const { refundId, ...requestParams } = params
  return apiRequest({
    ...requestParams,
    url: refundId ? `/mall4cloud_order/flash_order_refund/info/${refundId}` : '/mall4cloud_order/flash_order_refund/info',
    method: 'GET'
  })
}
export const listUserRefundPage = (params = {}) => {
  return apiRequest({
    ...params,
    url: '/mall4cloud_order/order_refund/user_page',
    method: 'GET'
  })
}
export const listFlashRefundPage = (params = {}) => {
  return apiRequest({
    ...params,
    url: '/mall4cloud_order/flash_order_refund/page',
    method: 'GET'
  })
}
export const getStationInfoById = (params = {}) => {
  return apiRequest({
    ...params,
    url: '/mall4cloud_order/station/info_by_station_id',
    method: 'GET'
  })
}
export const getStationProductDelivery = (params = {}) => {
  return apiRequest({
    ...params,
    url: '/mall4cloud_order/station/ua/productDelivery',
    method: 'GET'
  })
}
export const getSpuStationList = (params = {}) => {
  return apiRequest({
    ...params,
    url: '/mall4cloud_order/station/ua/spu_station',
    method: 'POST'
  })
}
export const getUserStationList = (params = {}) => {
  return apiRequest({
    ...params,
    url: '/mall4cloud_order/station/ua/user_station',
    method: 'POST'
  })
}
export const saveOrderInvoice = (params = {}) => {
  return apiRequest({
    ...params,
    url: '/mall4cloud_order/order_invoice',
    method: 'POST'
  })
}
export const confirmOrder = (params = {}) => {
  return apiRequest({
    ...params,
    url: '/mall4cloud_order/order/confirm',
    method: 'POST'
  })
}
export const confirmFlashOrder = (params = {}) => {
  return apiRequest({
    ...params,
    url: '/mall4cloud_order/flash_order/confirm',
    method: 'POST'
  })
}
export const confirmCartSettlementV2 = (params = {}) => {
  return apiRequest({
    ...params,
    url: '/mall4cloud_order/app/v2/shop_cart/settlement',
    method: 'POST'
  })
}
export const submitOrder = (params = {}) => {
  return apiRequest({
    ...params,
    url: '/mall4cloud_order/order/submit',
    method: 'POST'
  })
}
export const submitFlashOrder = (params = {}) => {
  return apiRequest({
    ...params,
    url: '/mall4cloud_order/flash_order/submit',
    method: 'POST'
  })
}
export const applyOrderRefund = (params = {}) => {
  return apiRequest({
    ...params,
    url: '/mall4cloud_order/order_refund/apply',
    method: 'POST'
  })
}
export const applyFlashOrderRefund = (params = {}) => {
  return apiRequest({
    ...params,
    url: '/mall4cloud_order/flash_order_refund/apply',
    method: 'POST'
  })
}
export const submitRefundExpressInfo = (params = {}) => {
  return apiRequest({
    ...params,
    url: '/mall4cloud_order/order_refund/submit_express',
    method: 'POST'
  })
}
export const submitFlashRefundExpressInfo = (params = {}) => {
  return apiRequest({
    ...params,
    url: '/mall4cloud_order/flash_order_refund/submit_express',
    method: 'POST'
  })
}
export const postScoreOrderConfirm = (params = {}) => {
  return apiRequest({
    ...params,
    url: '/mall4cloud_order/score_order/confirm',
    method: 'POST'
  })
}
export const saveRecentlyStation = (params = {}) => {
  return apiRequest({
    ...params,
    url: '/mall4cloud_order/station/ua/one_recently_station',
    method: 'POST'
  })
}
export const updateOrderRefund = (params = {}) => {
  return apiRequest({
    ...params,
    url: '/mall4cloud_order/order_refund/update_refund',
    method: 'PUT'
  })
}
export const updateFlashOrderRefund = (params = {}) => {
  return apiRequest({
    ...params,
    url: '/mall4cloud_order/flash_order_refund/apply',
    method: 'POST'
  })
}
export const updateOrderStationByOrderId = (params = {}) => {
  return apiRequest({
    ...params,
    url: '/mall4cloud_order/my_station_order/order_station_by_order_id',
    method: 'PUT'
  })
}
export const applyRefundPlatformIntervention = (params = {}) => {
  return apiRequest({
    ...params,
    url: '/mall4cloud_order/order_refund/apply_platform_intervention',
    method: 'PUT'
  })
}
export const saveRefundInterventionVoucher = (params = {}) => {
  return apiRequest({
    ...params,
    url: '/mall4cloud_order/order_refund_intervention/save_intervention_voucher',
    method: 'PUT'
  })
}
export const applyFlashRefundPlatformIntervention = (params = {}) => {
  return apiRequest({
    ...params,
    url: '/mall4cloud_order/flash_order_refund/apply_platform_intervention',
    method: 'PUT'
  })
}
export const saveFlashRefundInterventionVoucher = (params = {}) => {
  return apiRequest({
    ...params,
    url: '/mall4cloud_order/flash_order_refund_intervention/save_intervention_voucher',
    method: 'PUT'
  })
}
export const cancelOrderRefund = (params = {}) => {
  return apiRequest({
    ...params,
    url: '/mall4cloud_order/order_refund/cancel',
    method: 'PUT'
  })
}
export const cancelFlashOrderRefund = (params = {}) => {
  return apiRequest({
    ...params,
    url: '/mall4cloud_order/flash_order_refund/cancel',
    method: 'PUT'
  })
}
export const cancelRefundPlatformIntervention = (params = {}) => {
  return apiRequest({
    ...params,
    url: '/mall4cloud_order/order_refund/cancel_platform_intervention',
    method: 'PUT'
  })
}
export const cancelFlashRefundPlatformIntervention = (params = {}) => {
  return apiRequest({
    ...params,
    url: '/mall4cloud_order/flash_order_refund/cancel_platform_intervention',
    method: 'PUT'
  })
}
